import React from 'react';

import styles from './ViewHost.module.scss';

export default function ViewHost(props) {
  return (
      <>
        {props.children}
      </>
  )
}
